<mat-toolbar>
    <h1>Capability Request</h1>
</mat-toolbar>
<mat-progress-bar *ngIf="loader.loaderState() | async" mode="indeterminate"></mat-progress-bar>
<router-outlet></router-outlet>
